<div class="seg-controls-widget">
  @if (rows.length) {
    @for (seg of rows; track trackByIndex($index)) {
      <div [style]="styles.section">
        <div [style]="styles.subHeading">{{ seg.segName }} — {{ labels.heading }}</div>
        @if (seg.controls.length) {
          <table [style]="styles.table">
            <thead>
              <tr>
                <th [style]="styles.headerCell">{{ labels.code }}</th>
                <th [style]="styles.headerCell">{{ labels.name }}</th>
                <th [style]="styles.headerCell">{{ labels.type }}</th>
                <th [style]="styles.headerCell">{{ labels.bucket }}</th>
                <th [style]="styles.headerCell">{{ labels.owner }}</th>
                <th [style]="styles.headerCell">{{ labels.status }}</th>
                <th [style]="styles.headerCell">{{ labels.target }}</th>
                <th [style]="styles.headerCell">{{ labels.actual }}</th>
                <th [style]="styles.headerCell">{{ labels.linkType }}</th>
              </tr>
            </thead>
            <tbody>
              @for (control of seg.controls; track trackByIndex($index)) {
                <tr>
                  <td [style]="styles.cell">{{ control.controlCode }}</td>
                  <td [style]="styles.cell">{{ control.controlName }}</td>
                  <td [style]="styles.cell">{{ control.controlType }}</td>
                  <td [style]="styles.cell">{{ control.controlBucketName }}</td>
                  <td [style]="styles.cell">{{ control.controlOwnerName }}</td>
                  <td [style]="styles.cell">{{ control.status }}</td>
                  <td [style]="styles.cell">{{ control.targetDates }}</td>
                  <td [style]="styles.cell">{{ control.actualDates }}</td>
                  <td [style]="styles.cell">{{ control.linkType }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p [style]="styles.noData">{{ labels.noData }}</p>
        }
      </div>
    }
  } @else {
    <p [style]="styles.noData">{{ labels.noData }}</p>
  }
</div>
